export const chickenEggData = [
    {
        performanceProgress: 'ปริมาณขาย',
        quantity: 'ตัน',
        January: '55,440',
        February: '49,172',
        March: '55,664',
        April: '56,515',
        May: '56,659',
        June: '56,360',
        July: '56,661',
        August: '57,015',
        September: '54,608',
        October: '57,199',
        November: '58,529',
        December: '62,089',
        total: '675,911',
    },
    {
        performanceProgress: 'มูลค่าขาย',
        quantity: 'ล้านบาท',
        January: '759',
        February: '674',
        March: '783',
        April: '817',
        May: '844',
        June: '856',
        July: '873',
        August: '898',
        September: '867',
        October: '909',
        November: '935',
        December: '990',
        total: '10,205',
    },
    {
        performanceProgress: 'ราคาขาย',
        quantity: 'บาท/ก.ก.',
        January: '13.7',
        February: '13.7',
        March: '14.1',
        April: '14.5',
        May: '14.9',
        June: '15.2',
        July: '15.4',
        August: '15.8',
        September: '15.9',
        October: '15.9',
        November: '16.0',
        December: '16.0',
        total: '15.1',
    },
    {
        performanceProgress: 'ต้นทุนรวม',
        quantity: 'บาท/ก.ก.',
        January: '(13.0)',
        February: '(13.2)',
        March: '(13.5)',
        April: '(13.6)',
        May: '(13.9)',
        June: '(14.6)',
        July: '(14.8)',
        August: '(14.9)',
        September: '(14.8)',
        October: '(14.7)',
        November: '(14.8)',
        December: '(15.0)',
        total: '(14.3)',
    },
    {
        performanceProgress: 'กำไรสุทธิ',
        quantity: 'บาท/ก.ก.',
        January: '0.7',
        February: '0.5',
        March: '0.6',
        April: '0.9',
        May: '1.0',
        June: '0.6',
        July: '0.6',
        August: '0.9',
        September: '1.1',
        October: '1.1',
        November: '1.2',
        December: '0.9',
        total: '0.8',
    },
    {
        performanceProgress: '',
        quantity: 'ล้านบาท',
        January: '39',
        February: '26',
        March: '31',
        April: '48',
        May: '54',
        June: '36',
        July: '33',
        August: '49',
        September: '59',
        October: '66',
        November: '70',
        December: '58',
        total: '570',
    },
    {
        performanceProgress: '',
        quantity: '%',
        January: '5.1%',
        February: '3.8%',
        March: '4.0%',
        April: '5.9%',
        May: '6.4%',
        June: '4.2%',
        July: '3.8%',
        August: '5.5%',
        September: '6.8%',
        October: '7.2%',
        November: '7.5%',
        December: '5.9%',
        total: '5.6%',
    },
]